<template>
  <div id="automated-message-logs" class=" custom-modal">
    <transition name="el-fade-in" mode="out-in">
      <HolaconLottie v-if="loading == 'updateScreenLoading'" key="create-loading" />
      <el-row v-else key="content-loading">
        <div class="modal-body" id="scroll-area">
          <el-row :gutter="24">
            <el-col :span="24" class="mb-2">
              <el-button type="primary" icon="fas fa-search" size="mini" @click="isFilterEnabled = !isFilterEnabled" round>{{ $t("components.automatedmessages.automatedLogs.filter") }}</el-button>
            </el-col>
            <transition name="el-zoom-in-top" mode="out-in">
              <el-col :span="24" v-if="isFilterEnabled">
                <div class="mb-2 automated-message-filter">
                  <div class="filter-body">
                    <el-row :gutter="16" class="mt-2">
                      <el-col :span="24">
                        <div class="registerform-input-container">
                          <div class="custom-label">
                            <label>{{ $t("components.automatedmessages.automatedLogs.search") }}</label>
                          </div>
                          <el-input v-model="filter.participantNo" clearable :placeholder="$t('components.automatedmessages.automatedLogs.participantNo')"></el-input>
                          <!-- <span class="text-danger"> {{ $errorMessage('schemeID', validationErrors) }}</span> -->
                        </div>
                      </el-col>
                    </el-row>
                    <el-row :gutter="16" class="mt-2">
                      <el-col :span="12">
                        <div class="registerform-input-container">
                          <div class="custom-label">
                            <label>{{ $t("components.automatedmessages.automatedLogs.draft") }}</label>
                          </div>
                          <el-select v-model="filter.automatedMessageId" :placeholder="$t('components.automatedmessages.automatedLogs.all')" filterable clearable @clear="filter.automatedMessageId = null">
                            <el-option v-for="(option, index) in $store.state.automatedmessages.items" :label="option.title" :value="option.id" :key="index"></el-option>
                          </el-select>
                          <!-- <span class="text-danger"> {{ $errorMessage('schemeID', validationErrors) }}</span> -->
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div class="registerform-input-container">
                          <div class="custom-label">
                            <label>{{ $t("components.automatedmessages.automatedLogs.status") }}</label>
                          </div>
                          <el-select v-model="filter.status" :placeholder="$t('components.automatedmessages.automatedLogs.all')" clearable @clear="filter.status = null" filterable>
                            <el-option v-for="(option, index) in getEnums.find(x => x.title == 'AutomatedMessageLogStatus').enums.filter(x => x.key != 100)" :label="option.displayName" :value="option.key" :key="index"></el-option>
                          </el-select>
                          <!-- <span class="text-danger"> {{ $errorMessage('schemeID', validationErrors) }}</span> -->
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                  <div class="filter-footer d-flex justify-content-between mt-2">
                    <div class="left-buttons">
                      <el-button size="mini" @click="isFilterEnabled = !isFilterEnabled">{{ $t("components.automatedmessages.automatedLogs.close") }}</el-button>
                    </div>
                    <div class="right-buttons">
                      <el-button size="mini" @click="filterReset" type="primary">{{ $t("components.automatedmessages.automatedLogs.reset") }}</el-button>
                    </div>
                  </div>
                </div>
              </el-col>
            </transition>
            <el-col :span="24" v-if="items.length > 0">
              <div class="custom-grid-table-header automated-message-header">
                <span>{{ $t("components.automatedmessages.automatedLogs.participant") }}</span>
                <span>{{ $t("components.automatedmessages.automatedLogs.messageNameTypeSubject") }}</span>
                <span>{{ $t("components.automatedmessages.automatedLogs.postMessageStatusAction") }}</span>
              </div>
              <div class="automated-message-container">
                <div class="item" v-for="item in items" :key="item.id">
                  <div class="participant-card-mini mini" v-if="item.participant != null">
                    <div class="participant-card-mini-right">
                      <div class="participant-card-mini-num d-block"># {{ item.participant.participantNo }}</div>
                      <div class="participant-card-mini-title">{{ item.participant.firstName }} {{ item.participant.lastName }}</div>
                      <div class="participant-card-mini-container">
                        <span><i class="fas fa-circle" :style="{ color: item.participant.tagColor }"></i> {{ item.participant.tag }}</span>
                        <span v-if="item.targetAddress != null">{{ item.targetAddress }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="log-content">
                    <div class="message-type">{{ getEnumsDisplay("AutomatedMessageType", item.type) }}</div>
                    <div class="message-content">
                      <el-popover placement="right" :title="item.messageTitle" width="400" trigger="click">
                        <div v-html="item.messageBody"></div>
                        <span slot="reference" class="cursor-pointer"><i class="el-icon-info"></i></span>
                      </el-popover>
                      <span>{{ item.messageTitle }}</span>
                    </div>
                  </div>
                  <div class="log-content">
                    <!-- <div class="history">{{getEnumsDisplay('AutomatedMessageLogStatus', item.status)}} - {{$moment(item.createDate).format('DD MMMM YYYY, ddd HH:mm')}}</div> -->
                    <div class="history" v-for="history in item.history" :key="history.id">{{ getEnumsDisplay("AutomatedMessageLogStatus", history.status) }} - {{ $moment(history.date).format("DD MMMM YYYY, ddd HH:mm") }}</div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="24" v-else>
              <div>
                <HolaconLottieNoData class="w-100" key="create-loading" :source="'holacon-auto-message-lottie'" :title="$t('automatedMessages.automaticMessageRecords')" @btnAdd="false" @btnRefresh="false" :buttonAdd="false" :buttonRefresh="false" :loading="loading" />
              </div>
            </el-col>
          </el-row>
        </div>
      </el-row>
    </transition>

    <div class="modal-footer centered" slot="footer" v-if="loading != 'updateScreenLoading'">
      <div class="left-buttons">
        <!-- <el-button @click="$emit('closeDialog')">Kapat</el-button> -->
      </div>
      <div class="center-buttons" v-if="items.length > 0">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="filter.page" :page-sizes="[20, 30, 40, 50]" :page-size="filter.take" layout="total,sizes,prev, pager, next" :total="filter.total"></el-pagination>
      </div>
      <div class="right-buttons"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [],
      loading: false,
      timeout: null,
      resetFilter: {
        skip: 0,
        take: 20,
        participantNo: null,
        ids: [],
        total: 0,
        page: 1,
        status: null,
        automatedMessageId: null,
        automatedMessageIds: []
      },
      filter: {
        skip: 0,
        take: 20,
        participantNo: null,
        ids: [],
        total: 0,
        page: 1,
        status: null,
        automatedMessageId: null,
        automatedMessageIds: []
      },
      isFilterEnabled: false
    };
  },
  computed: {
    getEnums() {
      return this.$store.getters.getEnums;
    }
  },
  async created() {
    this.loading = "updateScreenLoading";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      await this.getData();
      this.loading = false;
    }, 500);
  },
  methods: {
    async getData() {
      var res = await this.$store.dispatch("getAutomatedMessageLogs", this.filter);
      if (!res.data.alert.hasError) {
        this.filter.total = res.data.data.totalCount;
        this.items = res.data.data.items;
      } else {
        this.$emit("closeDialog");
      }
    },
    filterReset() {
      this.filter = JSON.parse(JSON.stringify(this.resetFilter));
    },
    handleSizeChange(take) {
      this.filter.take = take;
    },
    handleCurrentChange(page) {
      this.filter.page = page;
      var scrollpage = document.querySelector("#scroll-area");
      scrollpage.scrollTo({ top: scrollpage.offsetTop, behavior: "smooth" });
    }
  },
  watch: {
    filter: {
      deep: true,
      handler() {
        if (this.timeout != null) clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {
          await this.getData();
        }, 500);
      }
    }
  }
};
</script>

<style lang="less" scoped>
#automated-message-logs {
  .automated-message-filter {
    background-color: #f1f1f1;
    border-radius: 8px;
    padding: 8px;
  }
  .automated-message-header {
    grid-template-columns: 200px 1fr 225px;
  }
  .automated-message-container {
    display: flex;
    flex-direction: column;
    .item {
      transition: all 0.5s;
      border-radius: 8px;
      display: grid;
      background-color: #f1f1f1;
      margin-bottom: 8px;
      grid-template-columns: 200px 1fr 225px;
      padding: 10px;
      gap: 0.5rem;
      align-items: center;

      &:last-child {
        margin-bottom: unset;
      }
      &.passive {
        background-color: #fff2f2 !important;
      }
      .log-content {
        display: flex;
        flex-direction: column;
        gap: 0.2rem;
        .message-type {
          text-decoration: underline;
          color: #03658c;
          font-weight: 500;
          font-size: 13px;
        }
        .message-content {
          display: flex;
          flex-direction: row;
          gap: 0.2rem;
        }
        .history {
          font-size: 12px;
          font-weight: 500;
        }
      }
      .log-participant {
        display: flex;
        flex-direction: column;
        gap: 0.2rem;
        .participant-tag {
          display: flex;
          flex-direction: row;
          gap: 0.4rem;
          .tag-color {
            width: 12px;
            height: 12px;
            border-radius: 50%;
          }
          align-items: center;
        }
      }
    }
  }
}
.registration-question {
  width: 100%;
  transition: 1s;
  margin-top: 18px;

  .sub-title {
    color: #292f3b;
    font-weight: 400;
    margin-bottom: 8px;
    font-size: 14px;
  }

  span {
    color: #505763;
    font-size: 13px;
    font-weight: 400;
  }

  .choice-questions {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
  }

  .el-input-number {
    width: 100% !important;
  }

  .el-date-editor {
    width: 100% !important;
  }

  .rate-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 150px;

    .el-slider {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/automatedmessages/AutomatedLogs.vue